import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddLabsToLabService(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $labServiceId: ID!
    $labIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addLabsToLabService(
                  labServiceId: $labServiceId
                  labIds: $labIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddLabsToLabServiceMutation,
  undefined,
  graphql.schema.AddLabsToLabServiceMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
